export var PostPopupMode;
(function(PostPopupMode) {
    PostPopupMode["JOURNAL"] = "journal";
    PostPopupMode["STATUS"] = "status";
})(PostPopupMode || (PostPopupMode = {}));

//# sourceMappingURL=types.js.map